export const getInitialValues = ({ attributes = [] }) => {
  const checkboxesValue = {};

  attributes.forEach(({ name }) => (checkboxesValue[name] = true));

  return {
    ...checkboxesValue,
  };
};
